import * as React from 'react';
import * as styles from './style.css';



export function Grid(props) {
    const {children} = props;
    return (
        <div className={styles.container}>
            {children}
        </div>
    )
}

export default Grid;



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/grid/index.tsx